import { render } from "./QrcodeCapture.vue?vue&type=template&id=8f8d4f42&ts=true&lang=html"
import script from "./QrcodeCapture.vue?vue&type=script&lang=ts"
export * from "./QrcodeCapture.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__